import React, { useState } from "react";
import { Draggable } from "react-beautiful-dnd";

import CellGroup from "../CellGroup";
import getSkillAreaWidth from "../../util/getSkillAreaWidth";

import "./index.scss";
import cx from "classnames";

export default function DraggableStudentRow(props) {
  const { student, index, activePeriods } = props;
  const { studentId } = student;

  const [isHovered, setIsHovered] = useState(false);

  if (!student) return null;

  return (
    <Draggable
      key={studentId}
      isDragDisabled={!!props.sort}
      draggableId={studentId}
      index={index}
    >
      {(provided, snapshot) => {
        const rowStyle = {
          minHeight: 50,
          display: "flex",
          backgroundColor: "white",
          ...provided.draggableProps.style,
        };

        let cellStyleClass = cx({
          "cell-style": true,
          "cell-dragging": snapshot.isDragging,
        });

        let nameCellClass = cx({
          "name-cell-style": true,
          "name-not-dragging": !snapshot.isDragging,
          "name-hovered": isHovered,
        });

        if (snapshot.isDragging) {
          rowStyle.boxShadow = "var(--generic-shadow)";
        }

        return (
          <div
            style={{ display: "flex" }}
            onMouseEnter={(e) => {
              if (!e.target.textContent) {
                setIsHovered(true);
              }
            }}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              style={rowStyle}
            >
              <div
                className={nameCellClass + " " + cellStyleClass}
                key={index}
                {...provided.dragHandleProps}
              >
                {student.studentName}
              </div>
              {activePeriods.map((gradeLabel, index) => {
                const period = student.periods[gradeLabel];
                return Object.keys(period).map((skillName) => {
                  const subSkills = period[skillName];
                  const width = getSkillAreaWidth({ subSkills });
                  const key = `${gradeLabel}-${skillName}`;
                  return (
                    <div
                      className={cellStyleClass}
                      key={key}
                      style={{
                        width: width,
                        minWidth: width,
                      }}
                    >
                      <CellGroup
                        subSkills={subSkills}
                        domain={student.domain}
                        skillArea={skillName}
                        setSkillModalData={props.setSkillModalData}
                        studentId={studentId}
                      />
                    </div>
                  );
                });
              })}
            </div>
          </div>
        );
      }}
    </Draggable>
  );
}
